/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ span: NonNullable<unknown> }} Tl_Rollup_LabelInputs */

const en_tl_rollup_label = /** @type {(inputs: Tl_Rollup_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`no own dates, children span ${i?.span}`)
};

const de_tl_rollup_label = /** @type {(inputs: Tl_Rollup_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ohne eigene Termine, Untervorgänge von ${i?.span}`)
};

/**
* | output |
* | --- |
* | "no own dates, children span {span}" |
*
* @param {Tl_Rollup_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_rollup_label = /** @type {((inputs: Tl_Rollup_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Rollup_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_rollup_label(inputs)
	return en_tl_rollup_label(inputs)
});